import { IDataSecurity } from '@nab/x-types';
import { loadScript } from '../utils/loadScript';
import { sdkLoggerInterface as log } from '../Logger/Logger';

/**
 * [[include:packages/consumer/sdk-browser/src/DataSecurityMgr/README.md]]
 */
abstract class DataSecurityMgr<TCONFIG = any, TDATA = string> implements IDataSecurity<TDATA> {
    public LibraryUrl: string;

    public config: TCONFIG;

    /**
     *
     * @param libraryUrl The URL used to add the script tag to the html dom.
     * @param {TCONFIG = any} config Pass in configs to override the configs need to change how the fraud libraries
     */
    constructor(libraryUrl: string, config?: TCONFIG) {
        this.LibraryUrl = libraryUrl;
        this.config = config;
    }

    protected async loadLibrary(): Promise<boolean> {
        try {
            if (this.LibraryUrl) {
                await loadScript(this.LibraryUrl, document.head);
                return true;
            }
            log.warn('No library provided');
            return false;
        } catch (e) {
            log.warn('Invalid or unreachable library Url provided');
            return false;
        }
    }

    /**
     * Must be implemented to initialise the library with its configuration and load the libraries.
     * We suggest that this be called as early as possible, possibly during class initialisation.
     */
    protected abstract initialise(): Promise<boolean>;

    /**
     * Must be implement to verify the the required settings and return the value to be used from the library.
     * Since it depends on the library to be loaded and set. We have made this asynchronous in nature.
     */
    public abstract getData(): Promise<TDATA>;

    /**
     * Can be overridden to show the support for context setting.
     * If no context needs to be set then return false.
     */
    public setContext(context: string): boolean {
        log.warn('Context setting is not supported by this library');
        return false;
    }
}

export { DataSecurityMgr };
